import { useEffect } from "react";
import "@/App.css";
import { Toaster } from "sonner";
import { initLenis } from "@/lib/lenis";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import NeFirma from "@/components/NeFirma";
import Marquee from "@/components/Marquee";
import Decoding from "@/components/Decoding";
import Founder from "@/components/Founder";
import Members from "@/components/Members";
import Coverage from "@/components/Coverage";
import Services from "@/components/Services";
import Gallery from "@/components/Gallery";
import Philosophy from "@/components/Philosophy";
import KabumPro from "@/components/KabumPro";
import Interview from "@/components/Interview";
import Reviews from "@/components/Reviews";
import ChatWidget from "@/components/ChatWidget";
import Calculator from "@/components/Calculator";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";

export default function App() {
  useEffect(() => {
    initLenis();
  }, []);

  return (
    <div className="App bg-ink text-zinc-100 antialiased" data-testid="app-root">
      <Header />
      <main>
        <Hero />
        <NeFirma />
        <Marquee />
        <Decoding />
        <Founder />
        <Members />
        <Coverage />
        <Services />
        <Gallery />
        <Philosophy />
        <KabumPro />
        <Interview />
        <Reviews />
        <Calculator />
      </main>
      <Footer />
      <WhatsAppButton />
      <ChatWidget />
      <Toaster
        theme="dark"
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#18181C",
            border: "1px solid rgba(212,175,55,0.35)",
            color: "#F4F4F5",
          },
        }}
      />
    </div>
  );
}
